import type { SVGProps } from 'react';

interface GrainWordmarkProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

// The full "GRAIN" wordmark shown in the expanded sidebar header (ported from
// the Phlex Icons::GrainLogo, recoloured to currentColor so it inherits the
// header text colour). The compact mark for the collapsed state is the existing
// primitives LogomarkIcon.
export function GrainWordmark({ className, ...props }: GrainWordmarkProps) {
  return (
    <svg
      fill="none"
      viewBox="0 0 172.74 38.18"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M19.45,0C23.25,0,26.68.99,29.8,2.92c3.17,1.93,5.56,4.42,7.18,7.59h-8.58c-2.24-2.44-5.41-3.85-8.94-3.85-6.92,0-12.38,5.41-12.38,12.43s5.46,12.43,12.38,12.43c5.36,0,9.46-2.91,11.08-7.49v-.05h-11.08v-6.6h18.93v1.82c.15,10.5-7.96,19.14-18.93,18.98C8.89,38.38-.21,29.49,0,19.09-.21,8.69,8.89-.2,19.45,0Z" fill="currentColor" />
      <path d="M57.21,22.42h-2.81v14.87h-6.81V.94h13.31c6.19,0,11.28,4.68,11.28,10.77,0,4.78-3.07,8.68-7.59,10.14l9.83,15.45h-7.9l-9.31-14.87ZM54.4,15.91h6.45c2.5,0,4.37-1.71,4.37-4.21s-1.87-4.26-4.37-4.26h-6.45v8.47Z" fill="currentColor" />
      <path d="M104.18,28.45h-14.14l-3.17,8.84h-6.92L93.42.94h7.49l13.47,36.35h-7.33l-2.86-8.84ZM101.58,21.9l-4.57-12.9-4.63,12.9h9.2Z" fill="currentColor" />
      <path d="M123.44.94h7.02v36.35h-7.02V.94Z" fill="currentColor" />
      <path d="M172.74.94v36.35h-7.07l-16.64-24.96v24.96h-6.91V.94h7.17l16.54,24.81V.94h6.92Z" fill="currentColor" />
    </svg>
  );
}
